import React, { ReactNode, FC } from "react";

import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalProps as ChakraModalProps,
} from "@chakra-ui/modal";
import useMediaQuery from "@UI/hooks/useMediaQuery";

export interface ModalProps extends ChakraModalProps {
  children: ReactNode;
  header?: ReactNode;
  closeButtonDisabled?: boolean;
}

export const Modal: FC<ModalProps> = ({
  children,
  header,
  closeButtonDisabled,
  ...props
}) => {
  const { isMobile } = useMediaQuery();

  return (
    <ChakraModal isCentered {...props}>
      <ModalOverlay />
      <ModalContent
        mb={isMobile ? "initial" : "auto"}
        {...(isMobile ? { borderBottomRadius: 0 } : {})}
      >
        <ModalHeader paddingBottom="6">
          {header}
          {!closeButtonDisabled && <ModalCloseButton />}
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
      </ModalContent>
    </ChakraModal>
  );
};
